import React, { useEffect } from 'react'
import { bool, func, string } from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import { Menu, Layout, Tooltip } from 'antd'
import {
	FolderOpenOutlined,
	TeamOutlined,
	LayoutOutlined,
	SettingOutlined,
	IdcardOutlined,
	DatabaseOutlined,
	DatabaseFilled,
	DashboardOutlined,
	ScheduleOutlined,
	FileSearchOutlined,
	AuditOutlined,
} from '@ant-design/icons'
import { getSettings } from '~/states/modules/settings'
import styles from './index.module.scss'
import logoBlack from '~/assets/logo-dark.svg'
import logoSmall from '~/assets/logo-small.png'
import { setInitialFolder } from '~/states/modules/folder'
import { Link } from 'react-router-dom'

const { Sider } = Layout

function SideBar({ collapsed, handleCollapsed, isWeb, selectedKey }) {
	const { data, error, loading } = useSelector(({ settings }) => settings)
	const loggedUser = useSelector(({ session }) => session)
	const dispatch = useDispatch()
	const { is_admin } = useSelector(({ session }) => session)
	const { accessFolders } = useSelector(({ folder }) => folder)
	const isSolicitant = !loggedUser?.perfil || loggedUser.perfil === 'solicitant'
	const hasLegalAccess =
		loggedUser?.hasLegalAccess ||
		loggedUser?.is_admin ||
		loggedUser?.is_company_admin

	useEffect(() => {
		if (!data.url && !loading && !error) dispatch(getSettings())
	}, [dispatch, data.url, error, loading])

	const handleFolderRowBack = () => {
		if (accessFolders.length !== 0) {
			dispatch(setInitialFolder())
		}
	}

	const isColapsed = useMediaQuery({
		query: '(max-width: 1200px)',
	})

	const getMenuItems = () => {
		const items = []

		if (isSolicitant || !hasLegalAccess)
			return [
				{
					key: 'demands',
					icon: (
						<ScheduleOutlined
							className={styles.icon}
							style={{ fontSize: 18 }}
						/>
					),
					label: <Tooltip className={styles.tooltip}>Demandas</Tooltip>,
					children: [
						{
							key: 'demands.list',
							// icon: (
							// 	<FileDoneOutlined
							// 		className={styles.icon}
							// 		style={{ fontSize: 18 }}
							// 	/>
							// ),
							label: (
								<Link to="/demands">
									<Tooltip className={styles.tooltip}>Lista</Tooltip>
								</Link>
							),
						},
					],
				},
			]

		if (loggedUser.company.config.has_document_dashboard) {
			items.push({
				key: 'dashboard',
				icon: (
					<DashboardOutlined
						className={styles.icons}
						style={{ fontSize: 18 }}
					/>
				),
				label: (
					<Link to="/dashboard">
						<Tooltip className={styles.tooltip}>Dashboard</Tooltip>
					</Link>
				),
			})
		}

		items.push({
			key: '/',
			icon: (
				<FolderOpenOutlined className={styles.icons} style={{ fontSize: 18 }} />
			),
			label: (
				<Link to="/documents" onClick={handleFolderRowBack}>
					<Tooltip className={styles.tooltip}>Documentos</Tooltip>
				</Link>
			),
		})

		if (loggedUser.company.config.has_demands) {
			items.push({
				key: 'demands',
				icon: (
					<ScheduleOutlined className={styles.icon} style={{ fontSize: 18 }} />
				),
				label: <Tooltip className={styles.tooltip}>Demandas</Tooltip>,
				children: [
					{
						key: 'demands.list',
						// icon: (
						// 	<FileDoneOutlined
						// 		className={styles.icon}
						// 		style={{ fontSize: 18 }}
						// 	/>
						// ),
						label: (
							<Link to="/demands">
								<Tooltip className={styles.tooltip}>Lista</Tooltip>
							</Link>
						),
					},
					{
						key: 'demands.dashboard',
						// icon: (
						// 	<PieChartOutlined
						// 		className={styles.icon}
						// 		style={{ fontSize: 18 }}
						// 	/>
						// ),
						label: (
							<Link to="/demands/dashboard">
								<Tooltip className={styles.tooltip}>Dashboard</Tooltip>
							</Link>
						),
					},
				],
			})
		}

		items.push({
			key: 'reports',
			icon: (
				<FileSearchOutlined className={styles.icon} style={{ fontSize: 18 }} />
			),
			label: (
				<Link to="/reports">
					<Tooltip className={styles.tooltip}>Relatórios</Tooltip>
				</Link>
			),
		})

		if (loggedUser.is_company_admin) {
			items.push(
				{
					key: 'templates',
					icon: (
						<LayoutOutlined className={styles.icons} style={{ fontSize: 18 }} />
					),
					label: (
						<Link to="/models">
							<Tooltip className={styles.tooltip}>Modelos</Tooltip>
						</Link>
					),
				},
				{
					key: 'textDatabases',
					icon: (
						<DatabaseOutlined
							className={styles.icons}
							style={{ fontSize: 18 }}
						/>
					),
					label: (
						<Link to="/textdatabases">
							<Tooltip className={styles.tooltip}>Bancos de Textos</Tooltip>
						</Link>
					),
				},
				{
					key: 'internalDatabases',
					icon: (
						<DatabaseFilled className={styles.icons} style={{ fontSize: 18 }} />
					),
					label: (
						<Link to="/internaldatabases">
							<Tooltip className={styles.tooltip}>Bancos de Dados</Tooltip>
						</Link>
					),
				},
				{
					key: 'accessLogs',
					icon: (
						<AuditOutlined className={styles.icons} style={{ fontSize: 18 }} />
					),
					label: (
						<Link to="/access-logs">
							<Tooltip className={styles.tooltip}>Logs de Acesso</Tooltip>
						</Link>
					),
				}
			)
		}

		items.push({
			key: 'users',
			icon: <TeamOutlined className={styles.icons} style={{ fontSize: 18 }} />,
			label: (
				<Link to="/users">
					<Tooltip className={styles.tooltip}>Usuários</Tooltip>
				</Link>
			),
		})

		if (is_admin) {
			items.push({
				key: 'empresas',
				icon: (
					<IdcardOutlined className={styles.icons} style={{ fontSize: 18 }} />
				),
				label: (
					<Link to="/companies">
						<Tooltip className={styles.tooltip}>Empresas</Tooltip>
					</Link>
				),
			})
		}

		items.push({
			key: 'settings',
			icon: (
				<SettingOutlined className={styles.icons} style={{ fontSize: 18 }} />
			),
			label: (
				<Link to="/settings">
					<Tooltip className={styles.tooltip}>Configurações</Tooltip>
				</Link>
			),
		})

		return items
	}

	const getMobileMenuItems = () => [
		{
			key: '/',
			icon: <FolderOpenOutlined />,
			label: (
				<Link to="/documents" onClick={handleFolderRowBack}>
					Documentos
				</Link>
			),
		},
		{
			key: 'users',
			icon: <TeamOutlined />,
			label: <Link to="/users">Usuários</Link>,
		},
		{
			key: 'templates',
			icon: <LayoutOutlined />,
			label: <Link to="/models">Modelos</Link>,
		},
		{
			key: 'settings',
			icon: <SettingOutlined />,
			label: <Link to="/settings">Configurações</Link>,
		},
	]

	return (
		<>
			{isWeb ? (
				<Sider
					className={styles.sider}
					trigger={null}
					collapsed={isColapsed}
					collapsible>
					<div className={styles.logoWrapper}>
						<img
							src={data.url || logoSmall}
							alt="logo"
							className={isColapsed ? styles.logoCollapsed : styles.logo}
							onError={(e) => {
								e.target.onError = null
								e.target.src = logoSmall
							}}
						/>
					</div>
					<Menu
						className={styles.menu}
						mode="inline"
						defaultSelectedKeys={[selectedKey]}
						defaultOpenKeys={['demands']}
						items={getMenuItems()}
					/>
				</Sider>
			) : (
				<Sider
					collapsible
					collapsed={collapsed}
					onCollapse={handleCollapsed}
					collapsedWidth={0}
					defaultCollapsed={true}
					zeroWidthTriggerStyle={{
						top: '10px',
						color: '#fff',
						backgroundColor: '#001529',
					}}
					theme="light"
					className={styles.sidebar}>
					<div className={styles.logoWrapper}>
						<img src={logoBlack} alt="logo" className={styles.logo} />
					</div>
					<Menu
						defaultSelectedKeys={[selectedKey]}
						mode="inline"
						items={getMobileMenuItems()}
					/>
				</Sider>
			)}
		</>
	)
}

SideBar.propTypes = {
	collapsed: bool.isRequired,
	handleCollapsed: func.isRequired,
	isWeb: bool,
	selectedKey: string,
}

SideBar.deafultProps = {
	isWeb: true,
}

export default React.memo(SideBar)
